<template>
  <v-system-bar
    v-if="isApiNotAvailable"
    color="red darken-2"
    class="v-system-bar--default error-bar"
    :height="35"
    app
  >
    <div class="v-system-bar__description">
      <v-icon color="white">mdi-alert-circle-outline</v-icon>
      Sorry, the system's server is temporarily unavailable. Please try again
      later.
    </div>
    <v-icon color="white" small @click="hideBar">mdi-close</v-icon>
  </v-system-bar>
</template>

<script>
import { mapState } from "vuex";
import { NS_SET_API_AVAILABILITY } from "@/store/modules/layout/mutation-types";

export default {
  computed: {
    ...mapState("layout", {
      isApiNotAvailable: state => state.isApiNotAvailable
    })
  },
  methods: {
    hideBar() {
      this.$store.commit(NS_SET_API_AVAILABILITY, false);
    }
  }
};
</script>

<style lang="scss"></style>
